<!-- DESKTOP TRIGGER -->
<div class="hidden md:block fixed top-6 right-6 z-[3]">
  <button
    type="button"
    class="w-12 h-12 flex items-center justify-center rounded-full bg-transparent text-white drop-shadow-[0_1px_2px_rgba(255,255,255,0.6)]"
    aria-label="Menü öffnen"
    (click)="toggleDesktopMenu()"
    [attr.aria-expanded]="desktopMenuIsVisible"
  >
    <fa-icon
      [icon]="['fas', 'bars']"
      class="text-lg"
    ></fa-icon>
  </button>
</div>

<!-- DESKTOP SLIDE-IN MENU -->
<div
  class="hidden md:block fixed inset-0 z-[90]"
  [class.pointer-events-none]="!desktopMenuIsVisible"
>
  <!-- Backdrop -->
  <button
    type="button"
    class="absolute inset-0 w-full h-full bg-black/60 backdrop-blur-sm transition-opacity duration-[420ms] ease-out"
    aria-label="Menü schließen"
    (click)="closeDesktopMenu()"
    [class.opacity-0]="!desktopMenuIsVisible"
  ></button>

  <!-- Panel -->
  <aside
    class="fixed top-0 right-0 h-full w-[min(420px,90vw)] bg-[#0f0f0f] text-white shadow-2xl transition-transform duration-[420ms] ease-out"
    [class.translate-x-0]="desktopMenuIsVisible"
    [class.translate-x-full]="!desktopMenuIsVisible"
  >
    <div class="h-full flex flex-col px-10 py-8">
      <div class="flex items-center justify-between">
        <button
          type="button"
          aria-label="Menü schließen"
          (click)="closeDesktopMenu()"
          class="w-10 h-10 flex items-center justify-center rounded-full"
        >
          <fa-icon [icon]="['fas', 'xmark']" class="text-white text-lg"></fa-icon>
        </button>
      </div>

      <nav class="mt-12 flex flex-col gap-6">
        @for (link of links; track link.fields?.name) {
          @if (isExternalLink(link.fields.url)) {
            <a
              [href]="link.fields.url"
              class="font-primary text-[#E1CEB9] text-2xl uppercase tracking-wide hover:text-[#E1CEB9] hover:opacity-80 transition-all duration-300 ease-out"
              (click)="onDesktopNavigate()"
            >
              {{ link.fields.label }}
            </a>
          } @else {
            @if (link.fields.isAnchor) {
              <a
                [appScrollAnchor]="link.fields.url"
                class="font-primary text-[#E1CEB9] text-2xl uppercase tracking-wide hover:text-[#E1CEB9] hover:opacity-80 transition-all duration-300 ease-out hover:cursor-pointer"
                (click)="onDesktopNavigate()"
              >
                {{ link.fields.label }}
              </a>
            } @else {
              <a
                [routerLink]="routerLinkTarget(link.fields.url)"
                class="font-primary text-[#E1CEB9] text-2xl uppercase tracking-wide hover:text-[#E1CEB9] hover:opacity-80 transition-all duration-300 ease-out"
                (click)="onDesktopNavigate()"
              >
                {{ link.fields.label }}
              </a>
            }
          }
        }
      </nav>
    </div>
  </aside>
</div>

<!-- MOBILE BURGER (ausblenden, wenn Overlay offen) -->
@if (!mobileMenuIsVisible) {
  <div class="md:hidden fixed top-5 right-5 z-[200]">
    <button
      type="button"
      class="w-10 h-10 flex items-center justify-center rounded-md bg-transparent text-white drop-shadow-[0_1px_2px_rgba(255,255,255,0.6)]"
      aria-label="Menü öffnen"
      (click)="toggleMobileMenu()"
      [attr.aria-expanded]="mobileMenuIsVisible"
    >
      <fa-icon [icon]="['fas', 'bars']" class="text-xl"></fa-icon>
    </button>
  </div>
}

<!-- MOBILE FULLSCREEN MENU -->
@if (mobileMenuIsVisible) {
  <div class="fixed inset-0 z-[100]">
    <!-- Backdrop -->
    <button
      type="button"
      class="absolute inset-0 w-full h-full bg-black/60 backdrop-blur-sm z-[100]"
      aria-label="Menü schließen"
      (click)="closeMobileMenu()"
    ></button>

    <!-- Content -->
    <div
      class="relative z-[101] w-full h-full flex items-center justify-center"
    >
      <div
        class="navigation__overlay flex flex-col items-center gap-6 text-white uppercase font-light text-2xl"
      >
        @for (link of links; track link.fields?.name) {
          @if (isExternalLink(link.fields.url)) {
            <a
              [href]="link.fields.url"
              class="cursor-pointer whitespace-nowrap hover:text-[#F3EEE8] font-primary text-white text-xl transition-all duration-300 ease-out hover:text-2xl"
              (click)="onMobileNavigate()"
            >
              {{ link.fields.label }}
            </a>
          } @else {
            @if (link.fields.isAnchor) {
              <a
                [appScrollAnchor]="link.fields.url"
                class="cursor-pointer whitespace-nowrap hover:text-[#F3EEE8] font-primary text-white text-xl transition-all duration-300 ease-out hover:text-2xl"
                (click)="onMobileNavigate()"
              >
                {{ link.fields.label }}
              </a>
            } @else {
              <a
                [routerLink]="routerLinkTarget(link.fields.url)"
                class="cursor-pointer whitespace-nowrap hover:text-[#F3EEE8] font-primary text-white text-xl transition-all duration-300 ease-out hover:text-2xl"
                (click)="onMobileNavigate()"
              >
                {{ link.fields.label }}
              </a>
            }
          }
        }
      </div>

      <!-- Close button -->
      <button
        type="button"
        aria-label="Menü schließen"
        (click)="closeMobileMenu()"
        class="absolute top-5 right-5 z-[102]"
      >
        <fa-icon
          [icon]="['fas', 'xmark']"
          class="text-white text-3xl"
        ></fa-icon>
      </button>
    </div>
  </div>
}
